var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 2.33789H2.33341C2.024 2.33789 1.72725 2.46081 1.50846 2.6796C1.28966 2.89839 1.16675 3.19514 1.16675 3.50456V11.6712C1.16675 11.9806 1.28966 12.2774 1.50846 12.4962C1.72725 12.715 2.024 12.8379 2.33341 12.8379H10.5001C10.8095 12.8379 11.1062 12.715 11.325 12.4962C11.5438 12.2774 11.6667 11.9806 11.6667 11.6712V7.58789",
    stroke: "#2E3E4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7917 1.45619C11.0238 1.22412 11.3386 1.09375 11.6667 1.09375C11.9949 1.09375 12.3097 1.22412 12.5417 1.45619C12.7738 1.68825 12.9042 2.003 12.9042 2.33119C12.9042 2.65938 12.7738 2.97412 12.5417 3.20619L7.00008 8.74785L4.66675 9.33119L5.25008 6.99785L10.7917 1.45619Z",
    stroke: "#2E3E4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7838b25a.svg";
export { ForwardRef as ReactComponent };